package wizard

internal object BuildConfig {
  internal val wizardType: WizardType = WizardType.KmpLibrary
}
